import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { reportNewClaim } from 'src/app/my-sedgwick/functions/report-newclaim';
import { scrollToElement } from 'src/app/shared';
import { SubSink } from 'subsink';
import { DynamicEventBindService } from '../..';
import { ExternalLinkDialogComponent } from '../../../shared/components/controls/dialog/external-link-dialog.component';
import { ConfigurationService } from '../../services/configuration.service';
import { LearningCenterService } from '../../services/learning-center.service';
import { OpenFileService } from '../../services/openfile.service';
import { Session } from '../../services/session.service';
import { StickyMenuComponent } from '../../../shared/components/controls/sticky-menu/sticky-menu.component';
import { TranslationRequest } from 'src/app/shared/models/translation/translation-request';

@Component({
    selector: 'app-learning-center-ada',
    template: `
    <div #dynamicContentContainer class="tw-w-full tw-flex">
      <!-- CONTENT -->
      <div class="tw-w-full">
        <app-loading-panel [state]="loading ? 'Loading' : 'Loaded'">
          <ng-template #content>
            <!-- INTRODUCTION -->
            @if (isIntroduction) {
              <h2
                class="app-lc-header-2"
                id="lc-intro"
                role="heading"
                >
                {{ 'Introduction' | translation: translationRequest }}
              </h2>
            }
            @if (isMgr) {
              <div class="app-lc-text">
                <p
                  [innerHTML]="learningCenter.introductionResults[0]?.value"
                ></p>
              </div>
              @if (isWhatisADA) {
                <h2
                  [innerHTML]="learningCenter.introductionResults[1]?.value"
                  class="app-lc-header-2"
                  role="heading"
                ></h2>
              }
              <div class="app-lc-text tw-flex">
                <div class="tw-grow">
                  <p
                    [innerHTML]="learningCenter.introductionResults[2]?.value"
                  ></p>
                  <p
                    [innerHTML]="learningCenter.introductionResults[3]?.value"
                  ></p>
                </div>
                <div class="tw-flex-none app-pl2 tw-hidden md:tw-block">
                  <img
                    src="./assets/images/img_LC_introphone_desktop.webp"
                    width="69"
                    height="100"
                    alt=""
                    aria-hidden="true"
                    role="img"
                    />
                  </div>
                </div>
              } @else {
                <div class="app-lc-text">
                  <p
                    [innerHTML]="learningCenter.introductionResults[0]?.value"
                  ></p>
                </div>
                @if (isWhatisADA) {
                  <div class="app-lc-header">
                    {{ learningCenter.introductionResults[1].value }}
                  </div>
                }
                <div class="app-lc-text tw-flex">
                  <div class="tw-grow">
                    <p
                      [innerHTML]="learningCenter.introductionResults[2]?.value"
                    ></p>
                    <p
                      [innerHTML]="learningCenter.introductionResults[3]?.value"
                    ></p>
                  </div>
                  <div class="tw-flex-none app-pl2 tw-hidden md:tw-block">
                    <img
                      src="./assets/images/img_LC_introphone_desktop.webp"
                      width="69"
                      height="100"
                      alt=""
                      aria-hidden="true"
                      role="img"
                      />
                    </div>
                  </div>
                }
    
                <!-- INTRODUCTION END-->
                <!-- ADA Details-->
                <h2 class="app-lc-header-2" id="lc-details" role="heading">
                  ADA {{ 'Details' | translation: translationRequest }}
                </h2>
                @if (isMgr) {
                  <div>
                    @if (learningCenter.adaDetails[1]?.value) {
                      <p
                        class="app-lc-details-header"
                        [innerHTML]="learningCenter.adaDetails[0]?.value"
                      ></p>
                    }
                    <span [innerHTML]="learningCenter.adaDetails[1].value"></span>
                  </div>
                  <div class="tw-w-full tw-flex app-pb1 app-pt1 ng-star-inserted">
                    <div>
                      @if (learningCenter.adaDetails[3]?.value) {
                        <p
                          class="app-lc-details-header"
                          [innerHTML]="learningCenter?.adaDetails[2].value"
                        ></p>
                      }
                      <span
                        [innerHTML]="learningCenter?.adaDetails[3].value"
                      ></span>
                    </div>
                  </div>
                  <div class="tw-w-full tw-flex app-pb1 app-pt1 ng-star-inserted">
                    <div>
                      @if (learningCenter.adaDetails[5]?.value) {
                        <p
                          class="app-lc-details-header"
                          [innerHTML]="learningCenter?.adaDetails[4].value"
                        ></p>
                      }
                      <span
                        [innerHTML]="learningCenter?.adaDetails[5].value"
                      ></span>
                    </div>
                  </div>
                  <div class="tw-w-full tw-flex app-pb1 app-pt1 ng-star-inserted">
                    <div>
                      @if (learningCenter.adaDetails[7]?.value) {
                        <p
                          class="app-lc-details-header"
                          [innerHTML]="learningCenter?.adaDetails[6].value"
                        ></p>
                      }
                      <span
                        [innerHTML]="learningCenter?.adaDetails[7].value"
                      ></span>
                    </div>
                  </div>
                  <div class="tw-w-full tw-flex app-pb1 app-pt1 ng-star-inserted">
                    <div>
                      @if (learningCenter.adaDetails[9]?.value) {
                        <p
                          class="app-lc-details-header"
                          [innerHTML]="learningCenter?.adaDetails[8].value"
                        ></p>
                      }
                      <span
                        [innerHTML]="learningCenter?.adaDetails[9].value"
                      ></span>
                    </div>
                  </div>
                } @else {
                  <div class="tw-w-full tw-flex app-pb1 app-pt1 ng-star-inserted">
                    <div>
                      @if (learningCenter.adaDetails[1]?.value) {
                        <p
                          class="app-lc-details-header"
                          [innerHTML]="learningCenter?.adaDetails[0].value"
                        ></p>
                      }
                      <span
                        [innerHTML]="learningCenter?.adaDetails[1].value"
                      ></span>
                    </div>
                  </div>
                  <div class="tw-w-full tw-flex app-pb1 app-pt1 ng-star-inserted">
                    <div>
                      @if (learningCenter.adaDetails[3]?.value) {
                        <p
                          class="app-lc-details-header"
                          [innerHTML]="learningCenter?.adaDetails[2].value"
                        ></p>
                      }
                      <span
                        [innerHTML]="learningCenter?.adaDetails[3].value"
                      ></span>
                    </div>
                  </div>
                  <div class="tw-w-full tw-flex app-pb1 app-pt1 ng-star-inserted">
                    <div>
                      @if (learningCenter.adaDetails[5]?.value) {
                        <p
                          class="app-lc-details-header"
                          [innerHTML]="learningCenter?.adaDetails[4].value"
                        ></p>
                      }
                      <span
                        [innerHTML]="learningCenter?.adaDetails[5].value"
                      ></span>
                    </div>
                  </div>
                  <div class="tw-w-full tw-flex app-pb1 app-pt1 ng-star-inserted">
                    <div>
                      @if (learningCenter.adaDetails[7]?.value) {
                        <p
                          class="app-lc-details-header"
                          [innerHTML]="learningCenter?.adaDetails[6].value"
                        ></p>
                      }
                      <span
                        [innerHTML]="learningCenter?.adaDetails[7].value"
                      ></span>
                    </div>
                  </div>
                  <div class="tw-w-full tw-flex app-pb1 app-pt1 ng-star-inserted">
                    <div>
                      @if (learningCenter.adaDetails[9]?.value) {
                        <p
                          class="app-lc-details-header"
                          [innerHTML]="learningCenter?.adaDetails[8].value"
                        ></p>
                      }
                      <span
                        [innerHTML]="learningCenter?.adaDetails[9].value"
                      ></span>
                    </div>
                  </div>
                }
                <!-- SUBMITTING CLAIM INFO END-->
                <!-- SUBMITTING CLAIM INFO-->
    
                <h2 class="app-lc-header-2" id="lc-claim" role="heading">
                  ADA {{ 'Submitting Claim Informations' | translation: translationRequest }}
                </h2>
                @if (isMgr) {
                  <app-learning-center-section
                label="{{
                  learningCenter.submittingclaiminformations[0]?.value
                }}"
                    icon="1"
                    layout="bullet"
                    >
                    <p
                  [innerHTML]="
                    learningCenter?.submittingclaiminformations[1].value
                  "
                    ></p>
                    <p
                  [innerHTML]="
                    learningCenter.submittingclaiminformations[2]?.value
                  "
                    ></p>
                  </app-learning-center-section>
                  <app-learning-center-section
                label="{{
                  learningCenter.submittingclaiminformations[3]?.value
                }}"
                    icon="2"
                    layout="bullet"
                    >
                    <p
                  [innerHTML]="
                    learningCenter?.submittingclaiminformations[4].value
                  "
                    ></p>
                    @if (isShown) {
                      <p
                    [innerHTML]="
                      learningCenter.submittingclaiminformations[5].value
                    "
                      ></p>
                    }
                  </app-learning-center-section>
                  <app-learning-center-section
                label="{{
                  learningCenter.submittingclaiminformations[6]?.value
                }}"
                    icon="3"
                    layout="bullet"
                    >
                    <p
                  [innerHTML]="
                    learningCenter?.submittingclaiminformations[7].value
                  "
                    ></p>
                    <p
                  [innerHTML]="
                    learningCenter.submittingclaiminformations[8]?.value
                  "
                    ></p>
                    <p
                  [innerHTML]="
                    learningCenter?.submittingclaiminformations[9].value
                  "
                    ></p>
                    <p
                  [innerHTML]="
                    learningCenter.submittingclaiminformations[10].value
                  "
                    ></p>
                    <p
                  [innerHTML]="
                    learningCenter?.submittingclaiminformations[11].value
                  "
                    ></p>
                  </app-learning-center-section>
                  @if (
                    this.learningCenter.submittingclaiminformations[12].value
                    ) {
                    <app-learning-center-section
                label="{{
                  learningCenter.submittingclaiminformations[12]?.value
                }}"
                      icon="4"
                      layout="bullet"
                      >
                      <div
                        class="tw-w-full tw-flex tw-flex-col md:tw-flex-row tw-flex-wrap tw-justify-items-stretch"
                        >
                        @if (
                          this.claimConfigService.getFeatureAccess(
                          'UploadDocuments'
                          ) &&
                          isMgr &&
                          isShown
                          ) {
                          <app-learning-center-section
                            class="tw-basis-1/4 app-color-teal"
                            layout="icon-small"
                            icon="upload_file"
                            >
                            <a
                              tabindex="0"
                              label="Documents"
                              class="go-to-documents-upload"
                              (click)="redirectToDocUpload()"
                              >
                              {{ 'Upload documents' | translation: translationRequest }}</a
                              >
                            </app-learning-center-section>
                          }
                          @if (
                            learningCenter.submittingclaiminformations[14]?.value
                            ) {
                            <app-learning-center-section
                              class="tw-basis-1/4"
                              layout="icon-small"
                              icon="mail"
                              >
                              {{ 'Mail' | translation: translationRequest }}:<br />
                              <span
                      [innerHTML]="
                        learningCenter.submittingclaiminformations[14]?.value
                      "
                              ></span>
                            </app-learning-center-section>
                          }
                          @if (
                            learningCenter.submittingclaiminformations[15]?.value
                            ) {
                            <app-learning-center-section
                              class="tw-basis-1/4"
                              layout="icon-small"
                              icon="fax"
                              >
                              {{ 'Fax' | translation: translationRequest }}:<br />
                              <span
                      [innerHTML]="
                        learningCenter.submittingclaiminformations[15]?.value
                      "
                              ></span>
                            </app-learning-center-section>
                          }
                          @if (
                            learningCenter.submittingclaiminformations[16]?.value
                            ) {
                            <app-learning-center-section
                              class="tw-basis-1/4"
                              layout="icon-small"
                              icon="laptop_mac"
                              >
                              {{ 'Email' | translation: translationRequest }}:<br />
                              <span
                      [innerHTML]="
                        learningCenter.submittingclaiminformations[16]?.value
                      "
                              ></span>
                            </app-learning-center-section>
                          }
                        </div>
                      </app-learning-center-section>
                    }
                  } @else {
                    <app-learning-center-section
                label="{{
                  learningCenter.submittingclaiminformations[0]?.value
                }}"
                      icon="1"
                      layout="bullet"
                      >
                      <p
                  [innerHTML]="
                    learningCenter?.submittingclaiminformations[1].value
                  "
                      ></p>
                      <p
                  [innerHTML]="
                    learningCenter.submittingclaiminformations[2]?.value
                  "
                      ></p>
                    </app-learning-center-section>
                    <app-learning-center-section
                label="{{
                  learningCenter.submittingclaiminformations[3]?.value
                }}"
                      icon="2"
                      layout="bullet"
                      >
                      <p
                  [innerHTML]="
                    learningCenter?.submittingclaiminformations[4].value
                  "
                      ></p>
                      @if (isShown) {
                        <p
                    [innerHTML]="
                      learningCenter.submittingclaiminformations[5].value
                    "
                        ></p>
                      }
                    </app-learning-center-section>
                    <app-learning-center-section
                label="{{
                  learningCenter.submittingclaiminformations[6]?.value
                }}"
                      icon="3"
                      layout="bullet"
                      >
                      <p
                  [innerHTML]="
                    learningCenter?.submittingclaiminformations[7]?.value
                  "
                      ></p>
                      <p
                  [innerHTML]="
                    learningCenter.submittingclaiminformations[8]?.value
                  "
                      ></p>
                      <p
                  [innerHTML]="
                    learningCenter?.submittingclaiminformations[9]?.value
                  "
                      ></p>
                      <p
                  [innerHTML]="
                    learningCenter?.submittingclaiminformations[10]?.value
                  "
                      ></p>
                      <p
                  [innerHTML]="
                    learningCenter?.submittingclaiminformations[11]?.value
                  "
                      ></p>
                    </app-learning-center-section>
                    @if (
                      this.learningCenter.submittingclaiminformations[12].value
                      ) {
                      <app-learning-center-section
                label="{{
                  learningCenter.submittingclaiminformations[12]?.value
                }}"
                        icon="4"
                        layout="bullet"
                        >
                        <div
                          class="tw-w-full tw-flex tw-flex-col md:tw-flex-row tw-flex-wrap tw-justify-items-stretch"
                          >
                          @if (
                            this.claimConfigService.getFeatureAccess(
                            'UploadDocuments'
                            ) &&
                            !isMgr &&
                            isShown
                            ) {
                            <app-learning-center-section
                              class="tw-basis-1/4 app-color-teal"
                              layout="icon-small"
                              icon="upload_file"
                              >
                              <a
                                tabindex="0"
                                label="Documents"
                                class="go-to-documents-upload"
                                (click)="redirectToDocUpload()"
                                >{{ 'Upload documents' | translation: translationRequest }}</a
                                >
                              </app-learning-center-section>
                            }
                            @if (
                              learningCenter.submittingclaiminformations[14]?.value
                              ) {
                              <app-learning-center-section
                                class="tw-basis-1/4"
                                layout="icon-small"
                                icon="mail"
                                >
                                {{ 'Mail' | translation: translationRequest }}:<br />
                                <span
                      [innerHTML]="
                        learningCenter.submittingclaiminformations[14]?.value
                      "
                                ></span>
                              </app-learning-center-section>
                            }
                            @if (
                              learningCenter.submittingclaiminformations[15]?.value
                              ) {
                              <app-learning-center-section
                                class="tw-basis-1/4"
                                layout="icon-small"
                                icon="fax"
                                >
                                {{ 'Fax' | translation: translationRequest }}:<br />
                                <span
                      [innerHTML]="
                        learningCenter.submittingclaiminformations[15]?.value
                      "
                                ></span>
                              </app-learning-center-section>
                            }
                            @if (
                              learningCenter.submittingclaiminformations[16]?.value
                              ) {
                              <app-learning-center-section
                                class="tw-basis-1/4"
                                layout="icon-small"
                                icon="laptop_mac"
                                >
                                {{ 'Email' | translation: translationRequest }}:<br />
                                <span
                      [innerHTML]="
                        learningCenter.submittingclaiminformations[16]?.value
                      "
                                ></span>
                              </app-learning-center-section>
                            }
                          </div>
                        </app-learning-center-section>
                      }
                    }
                    <!-- SUBMITTING CLAIM INFO END-->
                    <!-- WHATS NEXT-->
                    @if (isWhatsNext) {
                      <h2
                        class="app-lc-header-2"
                        id="lc-what"
                        role="heading"
                        >
                        {{ "ADA What's Next" | translation: translationRequest }}
                      </h2>
                    }
                    @if (isMgr) {
                      <div class="right-wrap app-pl2 tw-hidden md:tw-block">
                        <img
                          src="./assets/images/img_LC_WhatsNext_computer.webp"
                          width="141"
                          height="100"
                          alt=""
                          role="img"
                          />
                        </div>
                        <p [innerHTML]="learningCenter.whatsnexts[0]?.value"></p>
                        @if (
                          (isShown && learningCenter.whatsnexts[3]?.value) ||
                          (learningCenter.whatsnexts[4]?.value &&
                          learningCenter.whatsnexts[5]?.value) ||
                          (learningCenter.whatsnexts[7]?.value &&
                          learningCenter.whatsnexts[8]?.value &&
                          learningCenter.whatsnexts[9]?.value &&
                          learningCenter.whatsnexts[9]?.value) ||
                          (this.claimConfigService.getConfigFeatureAccess(
                          'notificationpreferences'
                          ) &&
                          learningCenter.whatsnexts[5]?.value &&
                          learningCenter.whatsnexts[6]?.value)
                          ) {
                          <p
                            [innerHTML]="learningCenter.whatsnexts[1]?.value"
                          ></p>
                        }
                        <div>
                          @if (
                            isShown &&
                            (learningCenter.whatsnexts[3]?.value ||
                            learningCenter.whatsnexts[4]?.value ||
                            learningCenter.whatsnexts[5]?.value)
                            ) {
                            <app-learning-center-section
                              label="{{ learningCenter.whatsnexts[2]?.value }}"
                              icon="laptop_mac"
                              layout="icon"
                              >
                              <span
                                [innerHTML]="learningCenter.whatsnexts[3]?.value"
                              ></span>
                              <span
                                [innerHTML]="learningCenter.whatsnexts[4]?.value"
                              ></span>
                              <span
                                [innerHTML]="learningCenter.whatsnexts[5]?.value"
                              ></span>
                            </app-learning-center-section>
                          }
                          @if (learningCenter.whatsnexts[8]?.value) {
                            <app-learning-center-section
                              label="{{ learningCenter.whatsnexts[6]?.value }}"
                              icon="contact_phone"
                              layout="icon"
                              >
                              <p>
                                {{
                                learningCenter.whatsnexts[7]?.value +
                                ' ' +
                                learningCenter.whatsnexts[8]?.value +
                                ' ' +
                                learningCenter.whatsnexts[9]?.value
                                }}
                              </p>
                            </app-learning-center-section>
                          }
                        </div>
                      } @else {
                        <div class="right-wrap app-pl2 tw-hidden md:tw-block">
                          <img
                            src="./assets/images/img_LC_WhatsNext_computer.webp"
                            width="141"
                            height="100"
                            alt=""
                            role="img"
                            />
                          </div>
                          <p [innerHTML]="learningCenter.whatsnexts[0]?.value"></p>
                          @if (
                            (isShown && learningCenter.whatsnexts[3]?.value) ||
                            (learningCenter.whatsnexts[4]?.value &&
                            learningCenter.whatsnexts[5]?.value) ||
                            (learningCenter.whatsnexts[7]?.value &&
                            learningCenter.whatsnexts[8]?.value &&
                            learningCenter.whatsnexts[9]?.value &&
                            learningCenter.whatsnexts[9]?.value) ||
                            (this.claimConfigService.getConfigFeatureAccess(
                            'notificationpreferences'
                            ) &&
                            learningCenter.whatsnexts[5]?.value &&
                            learningCenter.whatsnexts[6]?.value)
                            ) {
                            <p
                              [innerHTML]="learningCenter.whatsnexts[1]?.value"
                            ></p>
                          }
                          <div>
                            @if (
                              isShown &&
                              (learningCenter.whatsnexts[3]?.value ||
                              learningCenter.whatsnexts[4]?.value ||
                              learningCenter.whatsnexts[5]?.value)
                              ) {
                              <app-learning-center-section
                                label="{{ learningCenter.whatsnexts[2]?.value }}"
                                icon="laptop_mac"
                                layout="icon"
                                >
                                <span
                                  [innerHTML]="learningCenter.whatsnexts[3]?.value"
                                ></span>
                                <span
                                  [innerHTML]="learningCenter.whatsnexts[4]?.value"
                                ></span>
                                <span
                                  [innerHTML]="learningCenter.whatsnexts[5]?.value"
                                ></span>
                              </app-learning-center-section>
                            }
                            @if (learningCenter.whatsnexts[8]?.value) {
                              <app-learning-center-section
                                label="{{ learningCenter.whatsnexts[6]?.value }}"
                                icon="contact_phone"
                                layout="icon"
                                >
                                <p>
                                  {{
                                  learningCenter.whatsnexts[7]?.value +
                                  ' ' +
                                  learningCenter.whatsnexts[8]?.value +
                                  ' ' +
                                  learningCenter.whatsnexts[9]?.value
                                  }}
                                </p>
                              </app-learning-center-section>
                            }
                          </div>
                        }
                        <h2 class="app-lc-header-2" id="lc-after" role="heading">
                          {{ 'ADA After The Decision is Made' | translation: translationRequest }}
                        </h2>
    
                        <div class="app-lc-text tw-flex">
                          <div class="tw-grow">
                            @if (isMgr) {
                              <b [innerHTML]="learningCenter.afterDecide[0]?.value"></b
                                ><br />
                                <p [innerHTML]="learningCenter.afterDecide[1]?.value"></p>
                                <p [innerHTML]="learningCenter.afterDecide[2]?.value"></p>
                              } @else {
                                <b [innerHTML]="learningCenter.afterDecide[0]?.value"></b
                                  ><br />
                                  <p [innerHTML]="learningCenter.afterDecide[1]?.value"></p>
                                  <p [innerHTML]="learningCenter.afterDecide[2]?.value"></p>
                                }
                              </div>
                            </div>
                            @if (!isShown) {
                              <h2
                                class="app-lc-header-2"
                                id="lc-how"
                                role="heading"
                                >
                                {{ 'How Do All of These Claims Work?' | translation: translationRequest }}
                              </h2>
                            }
                            @if (!isShown) {
                              <div class="text">
                                {{ 'Wondering what types of claims apply to what situations? Take a look at the table below for a quick overview.' | translation: translationRequest }}
                              </div>
                            }
    
                            @if (!isShown) {
                              <table class="tw-w-full" aria-label="Claims Information">
                                <thead>
                                  <tr>
                                    <th style="width:20%" colspan="1" scope="col"></th>
                                    <th style="width:20%" class="table-header" scope="col">
                                      {{ 'Short Term Disability' | translation: translationRequest }}
                                    </th>
                                    <th style="width:20%" class="table-header" scope="col">
                                      {{ 'FMLA/State Leave' | translation: translationRequest }}
                                    </th>
                                    <th style="width:20%" class="table-header" scope="col">
                                      {{ "Workers' Compensation" | translation: translationRequest }}
                                    </th>
                                    <th style="width:20%" class="table-header" scope="col">
                                      ADA
                                    </th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr>
                                    <th class="table-header-left" scope="row">
                                      {{ 'Unable to work due to an injury that occured outside of work' | translation: translationRequest }}
                                    </th>
                                    <td class="check-container">
                                      <mat-icon
                                        class="check"
                                        aria-label="Unable to work due to an injury that occured outside of work checked"
                                        tabindex="0"
                                        aria-hidden="false"
                                        >check</mat-icon
                                        >
                                      </td>
                                      <td class="check-container">
                                        <mat-icon
                                          class="check"
                                          aria-label="Unable to work due to an injury that occured outside of work checked"
                                          tabindex="0"
                                          scope="row"
                                          aria-hidden="false"
                                          >check</mat-icon
                                          >
                                        </td>
                                        <td></td>
                                        <td></td>
                                      </tr>
                                      <tr>
                                        <th class="table-header-left" scope="row">
                                          {{ 'Unable to work due to an injury that occured at work' | translation: translationRequest }}
                                        </th>
                                        <td></td>
                                        <td class="check-container">
                                          <mat-icon
                                            class="check"
                                            aria-label="Unable to work due to an injury that occured at work checked"
                                            tabindex="0"
                                            aria-hidden="false"
                                            >check</mat-icon
                                            >
                                          </td>
                                          <td class="check-container">
                                            <mat-icon
                                              class="check"
                                              aria-label="Unable to work due to an injury that occured at work checked"
                                              tabindex="0"
                                              aria-hidden="false"
                                              >check</mat-icon
                                              >
                                            </td>
                                            <td></td>
                                          </tr>
                                          <tr>
                                            <th class="table-header-left" scope="row">
                                              {{ 'Unable to work 2 days every month due to my own chronic health condition' | translation: translationRequest }}
                                            </th>
                                            <td></td>
                                            <td class="check-container">
                                              <mat-icon
                                                class="check"
                        aria-label="Unable to work 2 days every month due to my own chronic health
            condition checked"
                                                tabindex="0"
                                                aria-hidden="false"
                                                >check</mat-icon
                                                >
                                              </td>
                                              <td></td>
                                              <td></td>
                                            </tr>
                                            <tr>
                                              <th scope="row" class="table-header-left">
                                                {{ 'Unable to work for 3 weeks to care for an ill family member' | translation: translationRequest }}
                                              </th>
                                              <td></td>
                                              <td class="check-container">
                                                <mat-icon
                                                  class="check"
                                                  aria-label="Unable to work for 3 weeks to care for an ill family member checked"
                                                  tabindex="0"
                                                  aria-hidden="false"
                                                  >check</mat-icon
                                                  >
                                                </td>
                                                <td></td>
                                                <td></td>
                                              </tr>
                                              <tr>
                                                <th scope="row" class="table-header-left">
                                                  {{ 'Unable to be totally successful at work due to limited functionality' | translation: translationRequest }}
                                                </th>
                                                <td></td>
                                                <td></td>
                                                <td></td>
                                                <td class="check-container">
                                                  <mat-icon
                                                    class="check"
                                                    aria-label="Unable to be totally successful at work due to limited functionality checked"
                                                    tabindex="0"
                                                    aria-hidden="false"
                                                    >check</mat-icon
                                                    >
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          }
                                        </ng-template>
                                      </app-loading-panel>
                                      <div id='endOfElement' tabindex="-1">&nbsp;</div>
                                    </div>
    
                                    <!-- RHS MENU -->
                                    <div
                                      class="tw-hidden lg:tw-block tw-flex-none tw-max-w-[220px] app-lc-menu"
                                      >
                                      <app-sticky-menu
                                        #stickyMenu
                                        [currentSection]="currentSection"
                                        (sectionChange)="onSectionChange($event)"
                                        >
                                        <div class="app-pt2">
                                          <div class="app-lc-sticky-link"><b>ADA</b></div>
                                          <div
                                            class="app-lc-sticky-link"
                                            [class.active-sidelink]="currentSection === 'lc-intro'"
                                            >
                                            @if (isIntroduction) {
                                              <span (click)="scrollToSection('lc-intro')"
                                                >
                                                {{ 'Introduction' | translation: translationRequest }}</span
                                                >
                                            }
                                          </div>
                                          <div
                                            class="app-lc-sticky-link"
                                            [class.active-sidelink]="currentSection === 'lc-details'"
                                            >
                                            @if (isADADetails) {
                                              <a (click)="scrollToSection('lc-details')"
                                                >{{ 'ADA Details' | translation: translationRequest }}</a
                                                >
                                              }
                                            </div>
                                            <div
                                              class="app-lc-sticky-link"
                                              [class.active-sidelink]="currentSection === 'lc-claim'"
                                              >
                                              <a (click)="scrollToSection('lc-claim')"
                                                >{{ 'ADA Submitting Claim Information' | translation: translationRequest }}</a
                                                >
                                              </div>
                                              <div
                                                class="app-lc-sticky-link"
                                                [class.active-sidelink]="currentSection === 'lc-what'"
                                                >
                                                @if (isWhatsNext) {
                                                  <a (click)="scrollToSection('lc-what')"
                                                    >{{ "ADA What's Next" | translation: translationRequest }}</a
                                                    >
                                                  }
                                                </div>
    
                                                <div
                                                  class="app-lc-sticky-link"
                                                  [class.active-sidelink]="currentSection === 'lc-after'"
                                                  >
                                                  @if (isAfterDecision) {
                                                    <a (click)="scrollToSection('lc-after')"
                                                      >{{ 'ADA After The Decision is Made' | translation: translationRequest }}</a
                                                      >
                                                    }
                                                  </div>
                                                  @if (!isShown) {
                                                    <div
                                                      class="app-lc-sticky-link"
                                                      [class.active-sidelink]="currentSection === 'lc-how'"
                                                      >
                                                      <a (click)="scrollToSection('lc-how')"
                                                        >{{ 'How Do All of These Claims Work' | translation: translationRequest }}</a
                                                        >
                                                      </div>
                                                    }
                                                  </div>
                                                </app-sticky-menu>
                                              </div>
                                            </div>
    `,
    styles: [
        `
      table td {
        border-color: silver;
        border-style: solid;
        border-width: 0 1px 1px 0;
      }

      .tblcolumn {
        width: 20%;
      }

      .app-lc-details-header {
        //color: var(--color-teal);
        color: #171c20;
        font-size: 20px;
        font-weight: bold;
        line-height: 34px;
      }
      .app-lc-text {
      }

      .app-lc-menu {
        border-left: 1px solid var(--color-light-grey);
        padding-left: 16px;
        margin-left: 16px;
      }
      .left-wrap {
        float: left;
      }
      .right-wrap {
        float: right;
      }
      .img-pd-btm {
        padding-bottom: 75px;
      }
      .center {
        text-align: center;
      }
      .mat-icon {
        margin: auto;
      }
      p + p {
        margin-top: 10px;
      }
      .app-p {
        margin-top: 10px;
        margin-bottom: 10px;
      }
      .app-lc-header-details {
        border-bottom-left-radius: 10px;
        border-top-left-radius: 10px;
        text-align: center;
        padding: 20px 5px 10px 5px;
      }
      .app-lc-details {
        color: #fff;
        background-color: #026595;
        border-radius: 10px;
        margin: 15px auto;
        margin-top: 25px;
        display: table;
        width: 95%;
        padding-top: 0px;
        overflow: hidden;
        line-height: 200px;
      }

      .img_div {
        border-bottom-left-radius: 10px;
        border-top-left-radius: 10px;
        text-align: center;
        padding: 20px 5px 10px 5px;
      }
      .table-container {
      }
      .table-container > div {
        border-color: silver;
        border-style: solid;
        border-width: 0 1px 1px 0;
      }
      .check-container {
        text-align: center;
        vertical-align: middle;
        line-height: 48px;
      }
      .check {
        font-size: 48px;
        width: 48px;
        height: 48px;
        color: var(--sed-purple-80-color) !important;
      }
    `,
    ],
    standalone: false
})
export class LearningCenterAdaComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Input()
  isMgr: boolean;

  @Input()
  learningCenter: any;

  @Input()
  loading: boolean;
  isShown: boolean = false;
  scrollToElement = scrollToElement;
  @Input()
  lcType: string;
  @Input()
  translationRequest: TranslationRequest;

  isReportClaimLinkBound: boolean = false;
  isOpenfile: boolean = false;
  documentUrl: string;
  isLearnMoreLinkBound: boolean = false;
  isLearnMore: boolean = false;
  mappings: any;
  isIntroduction: boolean = false;
  isWhatisADA: boolean = false;
  isADADetails: boolean = false;
  isSubmittingClaim: boolean = false;
  isWhatsNext: boolean = false;
  isAfterDecision: boolean = false;
  currentSection: string = 'lc-intro';

  @ViewChild('dynamicContentContainer') container: ElementRef;
  @ViewChild('stickyMenu') stickyMenu!: StickyMenuComponent;

  private unlistens: (() => void)[] = [];
  constructor(
    private session: Session,
    public learningCenterService: LearningCenterService,
    public dialog: MatDialog,
    public openFileService: OpenFileService,
    public router: Router,
    private bindEvents: DynamicEventBindService,
    public claimConfigService: ConfigurationService
  ) {}
  subs = new SubSink();
  ngAfterViewInit() {
    //angular's innerHTML attribute doesnt bind click events so have to do this
    this.unlistens = this.bindEvents.bindDynamicEvents(
      this.container,
      this.mappings
    );
  }
  async ngOnInit() {
    this.buildDocumentLink();
    this.checkHeaderValues();
    this.mappings = [
      {
        selector: '.report-new-claim',
        action: this.reportClaim.bind(this),
      },
      {
        selector: '.medical-provider',
        action: this.openFileLink.bind(this),
      },
      {
        selector: '.learn-more',
        action: this.openLearnMore.bind(this),
      },
      {
        selector: '.go-to-personal-notif',
        route: '/PreferencesPage',
        queryParams: {
          source: this.learningCenter.claimInfo.source,
          claimId: this.learningCenter.claimInfo.claimId,
        },
      },
      {
        selector: '.go-to-comm-center',
        route: '/claims',
        queryParams: {
          source: this.learningCenter.claimInfo.source,
          claimId: this.learningCenter.claimInfo.claimId,
          focus: 'comm-center',
        },
      },
      {
        selector: '.go-to-pharmacy-card',
        route: '/pharmacy-card',
        queryParams: {
          source: this.learningCenter.claimInfo.source,
          claimId: this.learningCenter.claimInfo.claimId,
        },
      },
      {
        selector: '.go-to-documents',
        route: '/claims',
        queryParams: {
          source: this.learningCenter.claimInfo.source,
          claimId: this.learningCenter.claimInfo.claimId,
          focus: 'DOCUMENTS',
        },
      },
      {
        selector: '.go-to-documents-upload',
        route: '/upload-documents-in-documentstab',
        queryParams: {
          source: this.learningCenter.claimInfo.source,
          claimId: this.learningCenter.claimInfo.claimId,
          focus: 'documents',
          showDialog: true,
        },
      },
      {
        selector: '.go-to-documents-show',
        route: '/upload-documents-in-documentstab',
        queryParams: {
          source: this.learningCenter.claimInfo.source,
          claimId: this.learningCenter.claimInfo.claimId,
          focus: 'documents',
          showDialog: false,
        },
      },
    ];
    this.checkViaClaim();
  }
  buildDocumentLink() {
    if (!this.isMgr)
      this.documentUrl = `/claims?source=${this.learningCenter.claimInfo.source}&claimId=${this.learningCenter.claimInfo.claimId}&focus=DOCUMENTS`;
  }

  openFileLink(event: MouseEvent) {
    event.stopPropagation();
    this.openFileService.openfile();
  }

  reportClaim(event: MouseEvent) {
    event.preventDefault();
    reportNewClaim(this.dialog);
  }

  openLearnMore(event: MouseEvent) {
    event.preventDefault();
    const element = event.target as HTMLElement;
    let url = element.getAttribute('href');
    const dialogRef = this.dialog.open(ExternalLinkDialogComponent);
    this.subs.sink = dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        window.open(url, '_blank');
      }
    });
  }
  checkViaClaim() {
    if (this.learningCenter.claimInfo.claimId != null) {
      this.isShown = !this.isShown;
    }
  }

  redirectToDocUpload() {
    this.router.navigate(['../upload-documents-in-documentstab'], {
      queryParams: {
        source: this.learningCenter.claimInfo.source,
        claimId: this.learningCenter.claimInfo.claimId,
        focus: 'documents',
        showDialog: true,
      },
    });
  }

  checkHeaderValues() {
    if (this.checkArrayValue(this.learningCenter.introductionResults, 0)) {
      this.isIntroduction = true;
    }
    if (this.checkArrayValue(this.learningCenter.introductionResults, 2)) {
      this.isWhatisADA = true;
    }
    if (this.checkArrayValue(this.learningCenter.adaDetails, 0)) {
      this.isADADetails = true;
    }
    if (this.checkArrayValue(this.learningCenter.whatsnexts, 0)) {
      this.isWhatsNext = true;
    }
    if (this.checkArrayValue(this.learningCenter.afterDecide, 0)) {
      this.isAfterDecision = true;
    }
  }
  checkArrayValue(arr: any[], index: number) {
    const arrVal = arr.slice();
    if (index > 0) {
      arrVal.splice(index - 1, 1);
      return arrVal.some((obj) => obj.value !== '');
    } else {
      return arrVal.some((obj) => obj.value !== '');
    }
  }
  ngOnDestroy(): void {
    this.unlistens.forEach((unlisten) => unlisten());
    this.subs.unsubscribe();
  }

  onSectionChange(section: string) {
    this.currentSection = section;
  }

  scrollToSection(sectionId: string) {
    this.stickyMenu.scrollToSection(sectionId);
  }
}
